import {api_url, EXERCISE_TYPES, languages, levels, upload_path} from "../../_AE/Helpers";

export const CONTEXT = "exercises";
export const API_URI = api_url+"/"+CONTEXT;
export const UPLOAD_PATH = upload_path+"/"+CONTEXT
export const SEARCHABLE = languages.map(l=>`name_${l}`).concat(["weight","reps","sets","rest"]);
export const ROUTE_PREFIX = "/"+CONTEXT;
export const CONTEXT_TITLE = {
  singular: "Exercise",
  plural: "Exercises",
}
/**/


export const defaultSorted = [{ dataField: "id", order: "asc" }];
export const sizePerPageList = [
  { text: "3", value: 3 },
  { text: "5", value: 5 },
  { text: "10", value: 10 }
];
export const initialFilter = {
  filter: {
    // enabled: "",
  },
  sortOrder: "asc", // asc||desc
  sortField: "created_at",
  pageNumber: 1,
  pageSize: 10
};

export const defaultEntity = {
  "name_en": "",
  "name_ar": "",
  "name_fr": "",
  "types": [],
  "level": levels[0],
  "weight": 0,
  "reps": 0,
  "sets": 0,
  "rest": 0,
  "duration": 0,
  "instructions": [],
  "tips": [],
  "muscle": null,
  "equipment": null,
  "enabled": true
}


